import { getService } from 'data/function';
export class RealTimeSidebarProcessor {
    static get RealtimeSidebarService() {
        return getService('RealtimeSidebarService');
    }
    static async process({ message }) {
        const ticket = message.content && message.content.ticket;
        const canTransferWithoutAgents = message.content && message.content.canTransferWithoutAgents;
        await RealTimeSidebarProcessor.RealtimeSidebarService.openRealtimeSidebar({ ticket, canTransferWithoutAgents });
    }
}
